import { chmodSync } from "fs";
import { join } from "path";
import type { InvokeResult } from "./Command";
import { Command } from "./Command";

export class AddMiseCodegraphScript extends Command {
  async invoke(): Promise<InvokeResult> {
    const filePath = ".mise/scripts/codegraph.sh";

    if (this.fileExists(filePath) && !this.context.force) {
      return {
        success: false,
        message: this.formatMessage("⚠️  .mise/scripts/codegraph.sh already exists"),
        filePath
      };
    }

    const content = `#!/usr/bin/env bash
# Auto-generated by pjangler

REPO_ROOT="$(pwd)"
PROJECT_NAME="$(basename "$REPO_ROOT")"
CONTAINER_NAME="codegraph-mcp-$PROJECT_NAME"
CACHE_DIR="$REPO_ROOT/.codegraph"

# Deterministically generate a port based on the repository path
PORT=$(echo -n "$REPO_ROOT" | md5sum | awk '{print $1}' | tr -d 'a-f' | cut -c1-4)
# Ensure port is > 1024
PORT=$(( (PORT % 60000) + 1025 ))

if ! docker ps --format '{{.Names}}' | grep -q "^$CONTAINER_NAME$"; then
  echo "🚀 Starting CodeGraph MCP Server on port $PORT..."

  # Ensure the container isn't lingering in a stopped state
  docker rm -f "$CONTAINER_NAME" >/dev/null 2>&1 || true

  # Run the true Colby McHenry CodeGraph Docker image
  # which we built locally as colbymchenry-codegraph-mcp:latest
  docker run -d \\
    --name "$CONTAINER_NAME" \\
    --restart unless-stopped \\
    -p "$PORT:8045" \\
    -v "$REPO_ROOT:/repo" \\
    colbymchenry-codegraph-mcp:latest >/dev/null

  echo "✅ CodeGraph MCP running in background. SSE URL: http://localhost:$PORT/sse"
fi

# Run init inside the container to ensure the index is bootstrapped.
# We run this using the standard codegraph CLI inside the container
docker exec "$CONTAINER_NAME" codegraph init -i /repo >/dev/null 2>&1 || true

# Wire up the MCP server to local agents
WIRE_SCRIPT="$(dirname "$0")/codegraph-wire.sh"
if [ -x "$WIRE_SCRIPT" ]; then
  "$WIRE_SCRIPT"
fi
`;

    this.writeFile(filePath, content);

    if (!this.context.dryRun) {
      chmodSync(join(this.context.targetDir, filePath), 0o755);
    }

    return {
      success: true,
      message: this.formatMessage(this.context.dryRun ? "Would create .mise/scripts/codegraph.sh" : "✅ Created .mise/scripts/codegraph.sh"),
      filePath
    };
  }
}
